module.exports = {

  title: 'Case registration',

}



// WEBPACK FOOTER //
// ./src/i18n/lang/en.js